function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.074,
    height: 18.077,
    viewBox: "0 0 18.074 18.077",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 25983"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14894",
    d: "M10870.518 315.075v-2.5l5.4-5.111 4.7-4.5h2.178l.7 2-1.635 2.5-5.576 5.111-3.275 2.5z",
    transform: "translate(-10865.659 -302.112)",
    style: {
      fill: "#612166"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14892",
    d: "M27.83 5.722a2.458 2.458 0 0 0-3.484 0L15.5 14.589a.452.452 0 0 0-.127.267L15 18.05a.453.453 0 0 0 .452.506h.05l3.222-.334a.452.452 0 0 0 .271-.131L27.83 9.22a2.481 2.481 0 0 0 0-3.5zm-9.364 11.61-2.5.267.289-2.481 6.986-7 2.21 2.214zm7.62-7.642-2.21-2.219 1.107-1.116a1.6 1.6 0 0 1 2.214 0 1.568 1.568 0 0 1 0 2.214z",
    transform: "translate(-10.477 -4.998)",
    style: {
      fill: "#393939"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 14893",
    d: "M20.365 22.105a2.26 2.26 0 0 1-2.26 2.26H8.163a2.26 2.26 0 0 1-2.26-2.26v-9.942A2.26 2.26 0 0 1 8.163 9.9h6.779V9H8.163A3.163 3.163 0 0 0 5 12.163v9.942a3.163 3.163 0 0 0 3.163 3.163h9.942a3.163 3.163 0 0 0 3.163-3.163v-6.778h-.9z",
    transform: "translate(-5 -7.192)",
    style: {
      fill: "#393939"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.9d22b5194cab1837619a29109be9f4d2.svg";
export { ForwardRef as ReactComponent };